<template>
  <v-card>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Create Wholesale + Conditions</v-toolbar-title>
    </v-toolbar>

    <v-card-text class="space-y-2.5">
      <v-alert v-if="success" type="success" class="pa-0" outlined>
        Wholesale created successfully!
      </v-alert>

      <v-text-field v-model="form.name" dense outlined hide-details="auto" label="Wholesale Name"
                    :error-messages="errors.name" @change="storeToLocal" />
      <v-text-field v-model="form.description" dense outlined hide-details="auto" label="Description"
                    @change="storeToLocal" />
      <v-switch v-model="form.active" label="Active" @change="storeToLocal" />

      <v-divider class="my-4" />

      <v-row v-for="(cond, index) in form.conditions" :key="index" align="center">
        <v-col cols="3">
          <v-text-field v-model="cond.min_quantity" outlined hide-details="auto" label="Min Quantity" type="number"
                        dense />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="cond.discount_percentage" outlined hide-details="auto" label="Discount %" type="number"
                        dense />
        </v-col>
        <v-col cols="3">
          <v-text-field v-model="cond.discount_fixed" outlined hide-details="auto" label="Fixed Discount (₱)"
                        type="number" dense />
        </v-col>
        <v-col cols="3">
          <v-btn icon @click="removeCondition(index)">
            <v-icon text color="red">
              mdi-delete
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-btn class="my-2" text color="primary" @click="addCondition">
        <v-icon left>
          mdi-plus
        </v-icon> Add Condition
      </v-btn>

      <v-divider class="my-4" />

      <v-btn color="primary" @click="submit">
        Save
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import LocalStore from '@/lib/localStore'
import { ErrorPopup, SuccessPopup, camelToSnake } from '@/lib/utils'
import { LoadingPopup } from '../../../../lib/utils'

const defaultForm = () => ({
  name: '',
  description: '',
  active: true,
  conditions: [],
})

const localStore = new LocalStore({
  schema: {
    createWholesaleWithConditions: {
      ...defaultForm(),
      unsavedChanges: false,
    },
  },
})

export default {
  name: 'CreateWholesaleWithConditions',
  data() {
    return {
      form: defaultForm(),
      errors: {},
      success: false,
    }
  },
  created() {
    const saved = localStore.get('createWholesaleWithConditions')
    if (saved?.unsavedChanges) {
      this.form = saved
    }
  },
  methods: {
    async submit() {
      this.errors = {}
      try {
        const token = this.$store.state.auth.token
        const payload = this.toSnakeCase(this.form)
        await axios(token).post('/whole-sales', payload)
        this.success = true
        this.reset()
        this.$emit('created')
        SuccessPopup.fire({ title: 'Success', text: 'Wholesale and conditions created.' })
      } catch (e) {
        LoadingPopup.close()
        if (e?.response?.data?.errors) {
          this.errors = e.response.data.errors
          return
        }
        ErrorPopup.fire('Failed to create wholesale.')
      }
    },
    addCondition() {
      this.form.conditions.push({
        min_quantity: 1,
        discount_percentage: 0,
        discount_fixed: 0,
      })
      this.storeToLocal()
    },
    removeCondition(index) {
      this.form.conditions.splice(index, 1)
      this.storeToLocal()
    },
    storeToLocal() {
      localStore.set({
        createWholesaleWithConditions: {
          ...this.form,
          unsavedChanges: true,
        },
      })
    },
    reset() {
      this.form = defaultForm()
      this.errors = {}
      localStore.delete('createWholesaleWithConditions')
    },
    toSnakeCase(obj) {
      const convert = val =>
        Array.isArray(val)
          ? val.map(v => this.toSnakeCase(v))
          : typeof val === 'object' && val !== null
            ? Object.keys(val).reduce((acc, key) => {
              acc[camelToSnake(key)] = convert(val[key])
              return acc
            }, {})
            : val

      return convert(obj)
    },
  },
}
</script>